



import { Vue, Component } from "vue-property-decorator";

import CustomerList from "@/components/admin/customerList.vue";

@Component({
  name: "Customers",
  components: {
    CustomerList,
  },
})
export default class Items extends Vue {}
